<script setup lang="ts">
	import { PropType, computed } from "vue";

	// Util
	import { formatNumber } from "@/util/numbers";

	// Types & Interfaces
	import { IEmpireCostOverview } from "@/features/empire/empire.types";

	const props = defineProps({
		costOverview: {
			type: Object as PropType<IEmpireCostOverview>,
			required: true,
		},
	});

	const profitPerArea = computed(() => {
		return props.costOverview.totalAreaUsed > 0
			? props.costOverview.totalProfit / props.costOverview.totalAreaUsed
			: 0;
	});
</script>

<template>
	<div class="grid grid-cols-[auto_auto] grid-rows-2 sm:grid-rows-1 sm:grid-cols-[1fr_auto_auto_auto_auto_1fr] gap-6 child:child:text-center">
		<div class="sm:col-2">
			<div class="text-white/40 text-xs">{{ $t("empire.overview.profit") }}</div>
			<div class="text-white text-xl">
				{{ formatNumber(costOverview.totalProfit) }}
			</div>
			<div class="text-white/40 text-xs">
				{{
					formatNumber(
						(costOverview.totalProfit / costOverview.totalRevenue) *
							100
					)
				}}
				%
			</div>
		</div>
		<div>
			<div class="text-white/40 text-xs">{{ $t("empire.overview.revenue") }}</div>
			<div class="text-white text-xl">
				{{ formatNumber(costOverview.totalRevenue) }}
			</div>
		</div>
		<div>
			<div class="text-white/40 text-xs">{{ $t("empire.overview.cost") }}</div>
			<div class="text-white text-xl">
				{{ formatNumber(costOverview.totalCost) }}
			</div>
			<div class="text-white/40 text-xs">
				{{
					formatNumber(
						(costOverview.totalCost / costOverview.totalRevenue) *
							100
					)
				}}
				%
			</div>
		</div>
		<div>
			<div class="text-white/40 text-xs">{{ $t("empire.overview.profit_area") }}</div>
			<div class="text-white text-xl">
				{{ formatNumber(profitPerArea) }}
			</div>
		</div>
	</div>
</template>
